import { IconMail01, IconPhone } from "@pentabd/icons";
import { Avatar, Button, Text } from "@pentabd/ui";

import { useEmployeeDetails } from "@hooks/HRM/employee/useEmployee";
import { useAuth } from "@hooks/useAuth";
import { useLanguage } from "@hooks/useLanguage";
import { useUser } from "@hooks/useUser";

import { GetEmployeeDetails } from "@utils/getEmployeeDetails";

export const UserInfo = () => {
  const { language } = useLanguage();

  const { user } = useUser();
  const { employeeMasterId: id } = user || {};
  const { login } = useAuth();

  const employeeData = useEmployeeDetails(id);
  const { mobileNumber, email } = employeeData || {};
  const { employeeName, employeeDesignation, employeeUnit, employeeImage } =
    GetEmployeeDetails(employeeData);

  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-10">
      <div className="mt-10 d-flex flex-wrap gap-10 align-items-center">
        <Avatar name={employeeName} imageURL={employeeImage} size="lg" />
        <div className="d-flex flex-column gap-2">
          <Text color="subtitle2" size="xl" sizeType="fs">
            {employeeName}
          </Text>
          <Text color="subtitle2" size="2xl" sizeType="fs">
            {employeeDesignation}
          </Text>
          <Text color="subtitle2" size="2xl" sizeType="fs">
            {employeeUnit}
          </Text>
          <div className="d-flex gap-10 flex-wrap mt-5">
            <div className="d-flex gap-2 align-items-center border border-info px-8 p-3 rounded-pill">
              <IconPhone size={16} fill="info" />
              <Text color="info" size="2xl">
                {mobileNumber}
              </Text>
            </div>
            <div className="d-flex gap-2 align-items-center border border-success px-8 p-3 rounded-pill">
              <IconMail01 size={16} fill="success" />
              <Text color="success">{email}</Text>
            </div>
          </div>
        </div>
      </div>
      <Button
        size="sm"
        fill="fill"
        type="warning"
        onClick={() => login({ action: "UPDATE_PASSWORD" })}
      >
        {language === "bn" ? "পাসওয়ার্ড পরিবর্তন করুন" : "Update Password"}
      </Button>
    </div>
  );
};
